import {
  DescTitle,
  SubTitle,
  SubTitleSpan,
  Wrapper,
} from "./CustomSuBAndDescription.styled";

const CustomSuBAndDescription = ({ sub, spanSub, desc }) => (
  <Wrapper>
    {sub && (
      <SubTitle>
        {sub} {spanSub && <SubTitleSpan> {spanSub}</SubTitleSpan>}
      </SubTitle>
    )}
    {desc && <DescTitle>{desc}</DescTitle>}
  </Wrapper>
);

export { CustomSuBAndDescription };
